module.exports = __webpack_public_path__ + "img/P5181386.eb6667e9.jpg";